import { Component, OnInit } from '@angular/core';
import { DigimatrixService } from './services/digimatrix.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { environment } from './../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {

  constructor(private digiMatrixService: DigimatrixService, public translate: TranslateService, public platform: Platform) {
    translate.setDefaultLang('ar');  // Set default language

    if (localStorage.getItem('Hidaya_lang')) {
      translate.use(localStorage.getItem('Hidaya_lang')!);
    } else {
      translate.use('ar');
    }

    if (this.platform.IOS) {
      localStorage.setItem('platform', 'ios');
    } else if (this.platform.ANDROID) {
      localStorage.setItem('platform', 'android');
    } else {
      localStorage.setItem('platform', 'web');
    }
    console.log(environment.production); // Logs false for development environment

  }
  ngOnInit() {
    
    this.digiMatrixService.authLogin().subscribe(
      (response) => {

      },
      (error) => {
        console.error(error); // Handle authLogin error
      }
    );
  }

  switchLanguage(language: string) {
    this.translate.use(language);
  }
}
